// Port of api/fuel/app/classes/filter/package/games/game/prepare/rank.php
export default {
	run: function(local, global) {
		local.rank = []
		if (global.filter && global.filter.source && (global.filter.source.list || global.filter.source['list.sorted'])) {
			var position = (global.referenceIndex || []).indexOf(local.game_id) + 1
			var previousPosition = (global.rankPrevious || []).indexOf(local.game_id) + 1
			var isNew = previousPosition === 0 ? 1 : 0
			local.rank = {
				comment: (global.listComments && global.listComments[local.game_id]) || '',
				position: position > 0 ? position : 0,
				movement: isNew ? 0 : previousPosition - position,
				new: isNew
			}
		}
		return local
	}
}
